const CacheSlug = {
  forObjectTypes: 'Cosmic-Object-Types',
};

export default CacheSlug;
